export const RadioOptions = [
  {
    id: 1,
    label: 'Written',
    value: 'ASSESMENT',
  },
  {
    id: 2,
    label: 'Group',
    value: 'GROUP',
  },
  {
    id: 3,
    label: 'Face-to-Face',
    value: 'FACE_TO_FACE',
  },
  {
    id: 4,
    label: 'External Assessment',
    value: 'EXTERNAL_ASSESMENT',
  },
]

export const assessmentOptions = [
  {
    id: 1,
    label: 'Cognitive',
    value: 'COGNITIVE',
  },
  {
    id: 2,
    label: 'Technical',
    value: 'TECHNICAL',
  },
  {
    id: 3,
    label: 'Communication',
    value: 'COMUNICATION',
  },
]

export const optionTime = []

const rangeOfNumbers = (startNum, endNum) => {
  if (endNum - startNum >= 0) {
    optionTime.push({
      value: startNum,
      label: `${startNum} Min`,
    })
    return rangeOfNumbers(startNum + 5, endNum)
  } else {
    return optionTime
  }
}

rangeOfNumbers(5, 240)
